import React from "react";
import * as S from "./styles";
export var Bank = function Bank(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, React.createElement("path", {
    d: "M15.333 8c2.39-.153 4.756.557 6.667 2M31.333 12.667c0 1.472-1.194 2.666-2.666 2.666"
  }), React.createElement("path", {
    d: "M16 4.667c-1.102.004-2.2.129-3.273.373-.613-1.083-1.633-1.877-2.833-2.205-1.2-.328-2.482-.163-3.56.458 1.238.715 2.081 1.958 2.286 3.374C5.88 8.21 3.977 10.902 3.433 14H.667v5.333H4.26C6.14 23.24 10.667 26 16 26c6.993 0 12.667-4.773 12.667-10.667C28.667 9.44 22.993 4.667 16 4.667z"
  }), React.createElement("circle", {
    cx: "8",
    cy: "13.333",
    r: "1"
  }), React.createElement("path", {
    d: "M10 25.02L10 29.333M22 24.98L22 29.333"
  })));
};